class VtagzPhoneForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const checkbox = this.querySelector('#smsConsentCheckbox');
    const vtagzButton = this.querySelector('.vtagz-button');

    if (!checkbox || !vtagzButton) return;

    // Clear error when checkbox is checked
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        const errorEl = this.querySelector('#vtagz-error');
        if (errorEl) {
          errorEl.innerText = '';
          errorEl.style.display = 'none';
        }
      }
    });
  }
}

customElements.define('vtagz-phone-form', VtagzPhoneForm);
